import { createStore } from '@aibees/shared/store';
import { TableDataFetchingStoreData as StoreData } from './types';

const useTableDataFetchingStore = createStore<StoreData>(
  'table-data-fetching',
  (set) => ({
    isLoading: false,
    setIsLoading: (isLoading) => set({ isLoading }),
  })
);

export default useTableDataFetchingStore;
